// Shared chrome for the login / accept-invite / reset-password pages —
// matches the brand styling of the editor.

import { Sun } from 'lucide-react';

interface Props {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export default function AuthLayout({ title, subtitle, children, footer }: Props) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10" style={{ background: '#EFF5FA' }}>
      <div className="flex items-center gap-2 mb-6">
        <div className="w-9 h-9 bg-blue-100 rounded-md flex items-center justify-center">
          <Sun size={20} className="text-blue-700" />
        </div>
        <span className="font-display font-semibold text-slate-900 text-lg">Penobscot Morning</span>
      </div>
      <div className="w-full max-w-sm bg-white rounded-xl border border-slate-200 shadow-sm p-5 sm:p-7">
        <h1 className="font-display text-2xl text-slate-900 mb-1.5 leading-tight">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mb-5">{subtitle}</p>}
        {children}
      </div>
      {footer && <div className="mt-6 text-xs text-slate-500">{footer}</div>}
    </div>
  );
}
